'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  textStyle: 'label',
  mr: 3,
  mb: 1
};
var Label = {
  baseStyle: baseStyle
};
exports["default"] = Label;